import { Grid } from '@material-ui/core'
import classnames from 'classnames'
import React, { useState } from 'react'

import { monthDayYear } from '../../../../../utils/dateTools'
import DispensaryEditPromoDropdown from './DispensaryEditPromoDropdown'
import {
  StyledAlert,
  StyledCloseIcon,
  StyledCopyIcon,
  StyledDropdownGrid,
  StyledExpandIcon,
  StyledExpirationDate,
  StyledIconContainer,
  StyledPromoRowDetail,
} from './styled'
import { CustomerDispensaryPromo, MutatePromoProps } from './types'

import copyIcon from '../../../../../img/copy.png'

export interface DispensaryPromoRowProps {
  mutatePromoProps: MutatePromoProps
  promo: CustomerDispensaryPromo
}

const DispensaryPromoRow: React.FC<DispensaryPromoRowProps> = ({ promo, mutatePromoProps }) => {
  const [copied, setCopied] = useState(false)
  const [showEditPromo, setShowEditPromo] = useState(false)
  const toggleEditPromo = () => {
    setShowEditPromo(!showEditPromo)
  }
  const classNames = classnames({
    inactive: promo.inactive,
    expirationDate: !!promo.expirationDate,
  })
  const copyToClipboard = () => {
    navigator.clipboard.writeText(promo.dispensaryCode).then(() => {
      setCopied(true)
    })
  }
  const resetCopiedAlert = () => {
    setCopied(false)
  }
  return (
    <>
      <Grid container item>
        <Grid item xs={1}>
          <StyledIconContainer className={classNames} onClick={copyToClipboard}>
            <StyledCopyIcon src={copyIcon} className={classNames} />
          </StyledIconContainer>
        </Grid>
        <Grid item xs={5}>
          <StyledPromoRowDetail className={classNames}>
            {promo.inactive ? '(Inactive) ' : ''}
            {promo.dispensaryCode}
          </StyledPromoRowDetail>
        </Grid>
        <Grid item xs={5}>
          <StyledPromoRowDetail className={classNames}>
            {promo.rootPromoName}
            <br />
            <StyledExpirationDate>
              {promo.expirationDate ? `Expiration: ${monthDayYear(promo.expirationDate)}` : ''}
            </StyledExpirationDate>
          </StyledPromoRowDetail>
        </Grid>
        <Grid onClick={toggleEditPromo} item xs={1}>
          {/* TODO: wrap children with button and move onClick */}
          <StyledIconContainer className={classNames}>
            {showEditPromo ? (
              <StyledCloseIcon className={classNames} />
            ) : (
              <StyledExpandIcon className={classNames} />
            )}
          </StyledIconContainer>
        </Grid>
        {showEditPromo && (
          <StyledDropdownGrid item xs={12}>
            <DispensaryEditPromoDropdown {...mutatePromoProps} promo={promo} />
          </StyledDropdownGrid>
        )}
      </Grid>
      {copied && (
        <Grid item xs={12}>
          <StyledAlert type="success" onDismiss={resetCopiedAlert}>
            Code &quot;{promo.dispensaryCode}&quot; copied to clipboard!
          </StyledAlert>
        </Grid>
      )}
    </>
  )
}

export default DispensaryPromoRow
